import {defineStore} from 'pinia'
import RequestMixin from "controllers/vue_components/mixins/request"
import {setCachedOrganizationsCount} from "composables/useOrganizationsCountCache"

export const orgStore = defineStore('org_global', {
    state: () => {
        return {
            current_user: {},
            current_org: {},
            current_org_social_libraries: [],
            user_role_in_org: {},
            user_organizations: [],
            org_members: [],
            org_members_fetched: false,
            members_loading: false,
            members_error: null,
            showInviteModal: false,
            members_search_term: '',
            members_sort_by: 'user_email',
            members_sort_order: 'asc',
            members_page: {
                limit: 10,
                number: 1
            },
            notifications: {
                stats: {
                    total_notifications_count: 10,
                    unviewed_notifications_count: 0,
                    viewed_notifications_count: 0
                },
                list: []
            }
        }
    },

    actions: {
        async fetchUserOrganizations() {
            let response = await RequestMixin.methods.axiosRequest('GET', '/api/v1/organizations', {}, false)
            if(response.js_error == false && response.response.success) {
                this.user_organizations = response.response.data
                setCachedOrganizationsCount(this.user_organizations.length)
            }
        },

        async fetchNotificationsStats() {
            let response = await RequestMixin.methods.axiosRequest('GET', `/api/v1/organizations/${this.current_org.id}/notifications/stats`, {}, false)
            if(response.js_error == false && response.response.success) {
                this.notifications.stats = response.response.data
            }
        },

        async fetchOrgMembers() {
          let endpoint = `/api/v1/organizations/${this.current_org.id}/members?page[limit]=${this.members_page.limit}&page[number]=${this.members_page.number}` +
            `&sort_by=${this.members_sort_by}&sort_order=${this.members_sort_order}`

          if(this.members_search_term !== '') {
            endpoint = endpoint + `&search=${encodeURIComponent(this.members_search_term)}`
          }

          this.members_loading = true
          this.members_error = null
          let response = await RequestMixin.methods.axiosRequest('GET', endpoint, {}, false)
            if(response.js_error == false && response.response.success) {
                this.org_members = response.response.data.records
                this.members_page = response.response.data.page
            } else {
                this.members_error = 'Failed to load members.'
            }
          this.org_members_fetched = true
          this.members_loading = false
        },

        async updateCurrentOrg(data) {
            let response = await RequestMixin.methods.axiosRequest('PUT', `/api/v1/organizations/${this.current_org.id}`, data, false)
            if(response.js_error == false && response.response.success) {
                this.current_org = response.response.data
            }
            return response
        },

        async updateCurrentOrgSocialLinks(data) {
            let response = await RequestMixin.methods.axiosRequest('PUT', `/api/v1/organizations/${this.current_org.id}/social_libraries`, data, false)
            if(response.js_error == false && response.response.success) {
                this.current_org_social_libraries = response.response.data
            }
            return response
        },

        async fetchUserRoleInOrg(){
            let response = await RequestMixin.methods.axiosRequest('GET', `/api/v1/organizations/${this.current_org.id}/user_role_in_org`, {}, false)
            if(response.js_error == false && response.response.success) {
                this.user_role_in_org = response.response.data
            }
        },
    },
})